
const hasRoute = (router) => {
  return {
    inserted: function (el, binding, vnode) {
      const route = binding.value;
      const routeExists = router.options.routes.find(configRoute => configRoute.path === route);
      if (routeExists) {
        return;
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

const hasAnyRoute = (router) => {
  return {
    inserted: function (el, binding, vnode) {
      const routes = binding.value;
      for (let route of routes) {
        const routeExists = router.options.routes.find(configRoute => configRoute.path === route);
        if (routeExists) {
          return;
        }
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

export default {
  hasRoute,
  hasAnyRoute
};



// WEBPACK FOOTER //
// ./src/directives/routerDirectives.js